import script from "./Template4.vue?vue&type=script&setup=true&lang=ts"
export * from "./Template4.vue?vue&type=script&setup=true&lang=ts"

import "./Template4.vue?vue&type=style&index=0&id=42bb3511&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42bb3511"]])

export default __exports__